module.exports = "https://d2jau2w7zc1e7m.cloudfront.net/packs/4f0283c6ce28e888000e978e537a6a56.png";